import { useNavigate } from "react-router-dom";
import { PageFallback } from "@jana-technology/platform-ui";

import { LOGIN_ROUTE } from "constants/routing";

export const GatewayFallback = () => {
  const navigate = useNavigate();

  return (
    <PageFallback
      paragraph="Please log in and try again."
      onPrimaryClick={() => navigate(LOGIN_ROUTE)}
      primaryButtonText="Back to Login"
    />
  );
};

export default GatewayFallback;
